'use client';

import Link from 'next/link';
import { useAuth } from '@/lib/auth-context';

interface AuthLinkProps {
  href: string;
  children?: React.ReactNode;
  adminOnly?: boolean;
  className?: string;
}

export function AuthLink({
  href,
  children = 'View all →',
  adminOnly = false,
  className = 'text-sm text-blue-600 hover:text-blue-700 dark:text-blue-400'
}: AuthLinkProps) {
  const { role, isLoading } = useAuth();

  if (isLoading) {
    return null;
  }

  // Admin only: hide for delegate and viewer
  if (adminOnly && role !== 'admin') {
    return null;
  }

  // Default: hide for viewers only
  if (!adminOnly && role === 'viewer') {
    return null;
  }

  return (
    <Link href={href} className={className}>
      {children}
    </Link>
  );
}

// Convenience alias for backwards compatibility
export const ViewAllLink = AuthLink;
